import React from 'react';

import { CommonQuestionsContainer } from './styles';

import { StaticImage } from 'gatsby-plugin-image';

const questions = [
  {
    icon: (
      <StaticImage
        src="../../images/icons/hourglass.png"
        alt="Are there time limits?"
        height={75}
      />
    ),
    question: 'Are there time limits?',
    answer: `Yes there are time limits. From the date of accident for
    most claims unless you were under 18 when the injury
    occurred, the time limit is 3 years. There are some
    exceptions however and as such we recommend seeking
    legal advice as soon as possible.`,
  },
  {
    icon: (
      <StaticImage
        src="../../images/icons/compensation.png"
        alt="Who pays the compensation?"
        height={75}
      />
    ),
    question: 'Who pays the compensation?',
    answer: `Compensation is paid by the CTP (compulsory third
    party) insurer of the driver at-fault in the accident. In
    those situations where the 'at-fault' party is unknown,
    such as a 'hit and run' a claim can be made against the
    government as a 'nominal defendant.`,
  },
  {
    icon: (
      <StaticImage
        src="../../images/icons/passengers.png"
        alt="Can a passenger claim?"
        height={75}
      />
    ),
    question: 'Can a passenger claim?',
    answer: `Yes, as a passenger then you can claim, even if your
    driver or rider was at fault. Your claim will be made via
    the CTP (compulsory third party) insurer of the at-fault
    party. There are no financial or cost implications for the
    at-fault party. Everything is done by us with the CTP
    insurer.`,
  },
  {
    icon: (
      <StaticImage
        src="../../images/icons/bill.png"
        alt="How much will it cost?"
        height={75}
      />
    ),
    question: 'How much will it cost?',
    answer: `We act on behalf of Queenslanders throughout the
    state, including no obligation home visits from our
    offices in Brisbane, Logan, Gold Coast, Noosa and
    Maroochydore. If you don't live near any of these offices
    then we can either travel to you or manage your case by
    working with you on the phone or online.`,
  },
  {
    icon: (
      <StaticImage
        src="../../images/icons/risks.png"
        alt="Are there any risks?"
        height={75}
      />
    ),
    question: 'Are there any risks?',
    answer: `With Accident Legal even if you lose during the 
    precourt proceedings you won't have to pay the other
    side's legal costs. You really have nothing to lose!`,
  },
];

const CommonQuestions = () => {
  return (
    <CommonQuestionsContainer className="common_questions">
      <div className="common_questions__content">
        <h2 className="common_questions__heading">
          Common Questions &amp; Answers about Compensation Claims and Injuries
        </h2>
        <div className="common_questions__items">
          {questions.map(({ question, answer, icon }) => (
            <div className="common_questions__item" key={question}>
              {icon}
              <h3>{question}</h3>
              <p>{answer}</p>
            </div>
          ))}
        </div>
      </div>
    </CommonQuestionsContainer>
  );
};

export { CommonQuestions };
